import cn from 'classnames'
import React from 'react'

//
import { isExternalUrl } from '../helpers'
import Link from 'next/link'

const FooterMenu = ({ title = '', items = [], classes = '' }) => {
  return (
    <div className={cn('c-footer-menu', classes)}>
      {/* <div className="c-footer-menu__container-mobile">
        <ExpansionPanel label={title} classes={'c-footer__expansion-title'}>
          {items.length > 0 && (
            <ul className="c-footer-menu__item">
              {items.map((item, i) => (
                <li key={i} className="c-footer-menu__item">
                  {item.url && isExternalUrl(item.url) ? (
                    <a
                      className="c-footer-menu__link"
                      rel="noopener noreferrer"
                      target="_blank"
                      href={item.url}
                    >
                      {item.label}
                    </a>
                  ) : (
                    <Link href={item.url} className="c-footer-menu__link">
                      {item.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          )}
        </ExpansionPanel>
      </div> */}

      {title && <h4 className="c-footer-menu__title">{title}</h4>}

      {items.length > 0 && (
        <ul className="c-footer-menu__list">
          {items.map((item, i) => (
            <li key={i} className="c-footer-menu__item">
              {item.url && isExternalUrl(item.url) ? (
                <a
                  className="c-footer-menu__link"
                  rel="noopener noreferrer"
                  target="_blank"
                  href={item.url}
                >
                  {item.label}
                </a>
              ) : (
                <Link href={item.url} locale={false} className="c-footer-menu__link">
                  {item.label}
                </Link>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default FooterMenu
